module.exports = __webpack_public_path__ + "img/ceo.03274e22.png";